import type { HttpClient } from './http';
import type { WorkflowAuditDetail, WorkflowAuditListResponse } from './types';

export interface WorkflowAuditsApi {
  list(params?: {
    workflowId?: number;
    status?: string;
    trigger?: string;
    startedFrom?: string;
    search?: string;
    page?: number;
    limit?: number;
  }): Promise<WorkflowAuditListResponse>;
  get(id: number): Promise<WorkflowAuditDetail>;
}

export function createWorkflowAuditsApi(http: HttpClient): WorkflowAuditsApi {
  const base = '/workflow-audits';

  return {
    list: (params = {}) => {
      const search = new URLSearchParams();
      if (params.workflowId !== undefined) {
        search.set('workflowId', String(params.workflowId));
      }
      if (params.status) {
        search.set('status', params.status);
      }
      if (params.trigger) {
        search.set('trigger', params.trigger);
      }
      if (params.startedFrom) {
        search.set('startedFrom', params.startedFrom);
      }
      if (params.search) {
        search.set('search', params.search);
      }
      if (typeof params.page === 'number') {
        search.set('page', String(params.page));
      }
      if (typeof params.limit === 'number') {
        search.set('limit', String(params.limit));
      }
      const query = search.toString();
      const suffix = query ? `?${query}` : '';
      return http.get<WorkflowAuditListResponse>(`${base}${suffix}`);
    },
    get: (id) => http.get<WorkflowAuditDetail>(`${base}/${id}`),
  };
}
